import { EumApiCallOptions, EumApiDataMoldel, HttpMethods, EumApiConfig } from "./types";
import AxiosClient from "./AxiosClient";
export * from "./types";
import { VueAES128 } from "@appbase/util/vue-aes128";
import Vue from "vue";
import lsh from "@appbase/util/local-storage-helper";
class EumApiClient {
    private apiConfig: EumApiConfig;
    private axiosClient: AxiosClient;

    constructor(userConfig: EumApiConfig) {
        this.apiConfig = {
            // baseURL: baseUrl,
            timeout: userConfig.timeout,
            ...userConfig,
            requestConfig: {
                ...userConfig.requestConfig,
                headers: {
                    // Authorization: 'Bearer {token}',
                    "X-Requested-With": "XMLHttpRequest",
                    "X-EUM-TIMEZONE": this.getStandardTimezone(), //2022-06-19 타임존 정보를 헤더에 추가 함
                    "X-EUM-TIMEOFFSET": new Date().getTimezoneOffset(), //2022-06-19 타임존 정보를 헤더에 추가 함
                    ...userConfig.requestConfig?.headers,
                },
            },
        };
        this.axiosClient = new AxiosClient(this.apiConfig);

        (window as any).EumApiClient = this;
    }

    private getRequestEncryptHeader(headers: any) {
        try {
            // 로컬스토리지에 특정 값이 있는경우 암호화 하지 않음
            var lshValue = lsh.get("RequestEncryptHeader");
            if (lshValue == "NONE") {
                return "NONE";
            }

            // 헤더에 정의되어있는 경우 반환
            if (headers && headers["X-Eum-RequestEncrypt"]) {
                return headers["X-Eum-RequestEncrypt"];
            }

            var appConfig = Vue.prototype.getAppConfig("RequestEncryptHeader");

            return appConfig;
        } catch (err) {
            return "BASIC";
        }
    }

    private getStandardTimezone() {
        try {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (e) {
            let originDate = new Date().toLocaleDateString("en-us", {
                timeZoneName: "long",
                day: "numeric",
            });

            let strTimezone = originDate.split(",")[1].trim();

            return strTimezone != "" ? strTimezone : "";
        }
    }

    /**
     * 모든 요청 Url Querystring에 대한 암호화 진행
     * @param url plainUrl
     * @returns QueryString 암호화 완료된 URL 문자열
     */
    private getEncryptionURLParam(url: string) {
        var isUseLocalhostStr = true;
        var localhostStr = "http://localhost";
        var encryptUrl = url;
        try {
            var urlObj = new URL(localhostStr);
            if (url.startsWith("/")) {
                urlObj = new URL(localhostStr + url);
            } else if (url.startsWith("http://") || url.startsWith("https://")) {
                urlObj = new URL(url);
                isUseLocalhostStr = false;
            } else {
                return encryptUrl;
            }

            var urlParams = new URLSearchParams(urlObj.search);

            urlParams.forEach((value, key) => {
                urlParams.set(key, VueAES128.encrypt(value));
            });
            urlObj.search = urlParams.toString();
            var urlStr = urlObj.toString();
            if (isUseLocalhostStr) {
                encryptUrl = urlStr.substring(localhostStr.length, urlStr.length);
            } else {
                encryptUrl = urlStr;
            }
        } catch (err) {
            encryptUrl = url;
        }
        return encryptUrl;
    }

    private send<T>(method: HttpMethods, option?: EumApiCallOptions): Promise<T> {
        var { url, data, params, headers } = option || {};
        var invalidatedUrl: string = this.invalidateUrl(url || "");

        var requestEncryptHeader = this.getRequestEncryptHeader(headers); // 2024-12-04 모든 요청에 대해 암호화

        if (requestEncryptHeader !== "NONE") {
            if (requestEncryptHeader === "BASIC") {
                headers = {
                    ...headers,
                    "X-Eum-RequestEncrypt": requestEncryptHeader,
                };
                invalidatedUrl = this.getEncryptionURLParam(invalidatedUrl);

                //#region 모든 요청의 Params에 대한 암호화
                if (params) {
                    var paramsObject = Object.entries(params);
                    for (var i = 0; i < paramsObject.length; i++) {
                        var key = paramsObject[i][0];
                        var value = paramsObject[i][1];

                        if (value) {
                            var targetValue = value.toString();

                            if (value instanceof Date) {
                                targetValue = value.toUTCString();
                            }

                            (params as any)[key] = VueAES128.encrypt(targetValue);
                        }
                    }
                }
                //#endregion

                //#region Get을 제외한 Body에 들어가는 데이터에 대한 암호화
                if (data) {
                    data = { EncrpytValue: VueAES128.encrypt(JSON.stringify(data)) };
                }
                //#endregion
            }
        }

        const promise = this.axiosClient.send<EumApiDataMoldel<T>>(method, invalidatedUrl, data, params, headers);

        return promise.then<T>((data) => {
            if (data === undefined) {
                debugger;
            }

            if ((data as any).value) {
                return (data as any).value;
            }

            if (data && data.code === "ok") {
                if (data.isEncrypt === true) {
                    data.result = JSON.parse(VueAES128.decrypt(data.result as string));
                }
                return data.result;
            } else {
                throw (data || {}).error;
            }
        });
    }

    get<T>(option?: EumApiCallOptions): Promise<T> {
        return this.send<T>(HttpMethods.GET, option);
    }

    delete<T>(option?: EumApiCallOptions): Promise<T> {
        return this.send<T>(HttpMethods.DELETE, option);
    }

    put<T>(option?: EumApiCallOptions): Promise<T> {
        return this.send<T>(HttpMethods.PUT, option);
    }

    post<T>(option?: EumApiCallOptions): Promise<T> {
        return this.send<T>(HttpMethods.POST, option);
    }

    patch<T>(option?: EumApiCallOptions): Promise<T> {
        return this.send<T>(HttpMethods.PATCH, option);
    }

    invalidateUrl(path: string): string {
        var rootUrl = this.apiConfig.rootUrl;
        var url = "";
        if (path.startsWith("/")) {
            url = rootUrl + path;
        } else if (path.startsWith("http://") || path.startsWith("https://")) {
            url = path;
        } else {
            url = path;
        }
        return url;
    }
}
export default EumApiClient;
